// import React, { useState } from "react";
// import { Range } from "react-range";

// const MultiProgress = ({ min = 0, max = 100 }) => {
//   // Default state: total and handles are zero.
//   const [total, setTotal] = useState(0);
//   const [values, setValues] = useState([0, 0]);

//   // Calculate segments:
//   const firstSegment = values[0];
//   const secondSegment = values[1] - values[0];
//   const calculatedValue = total - values[1];

//   // Update total and recalc handle positions proportionally.
//   const handleTotalChange = (event) => {
//     const newTotal = parseInt(event.target.value, 10) || 0;
//     setTotal(newTotal);
//     if (newTotal > 0) {
//       if (total === 0) {
//         // If previous total was 0, initialize with default percentages.
//         const defaultLeft = Math.floor(newTotal * 0.3);
//         const defaultRight = Math.floor(newTotal * 0.55);
//         setValues([defaultLeft, defaultRight]);
//       } else {
//         // Recalculate handles proportionally.
//         const leftRatio = values[0] / total;
//         const rightRatio = values[1] / total;
//         const newLeft = Math.floor(newTotal * leftRatio);
//         const newRight = Math.floor(newTotal * rightRatio);
//         setValues([newLeft, Math.min(newRight, newTotal)]);
//       }
//     } else {
//       // When total is 0, reset handle positions.
//       setValues([0, 0]);
//     }
//   };

//   // Handle slider changes:
//   const handleChange = (newValues) => {
//     let [left, right] = newValues;
//     // Ensure the left handle does not pass the right handle.
//     if (left > right) {
//       left = right;
//     }
//     left = Math.max(min, left);
//     right = Math.min(total, right);
//     setValues([left, right]);
//   };

//   // Only calculate percentages if total > 0.
//   const firstPercent = total > 0 ? (values[0] / total) * 100 : 0;
//   const secondPercent = total > 0 ? (values[1] / total) * 100 : 0;

//   // Determine track background.
//   const trackBackground =
//     total > 0
//       ? `linear-gradient(
//           to right,
//           green 0%,
//           green ${firstPercent}%,
//           yellow ${firstPercent}%,
//           yellow ${secondPercent}%,
//           red ${secondPercent}%,
//           red 100%
//         )`
//       : "gray";

//   return (
//     <div className="flex flex-col items-center w-full p-4">
//       {/* Total value input */}
//       <label className="mb-2 text-lg font-semibold">Enter Total Value:</label>
//       <input
//         type="number"
//         value={total}
//         onChange={handleTotalChange}
//         className="mb-4 p-2 border border-gray-300 rounded w-32 text-center"
//         min={min}
//         max={max}
//       />

//       {/* Display the three segments */}
//       <div className="mb-2 text-lg font-semibold">
//         Distribution: [{firstSegment} - {secondSegment} - {calculatedValue}]
//       </div>

//       {/* Render the slider only if total > 0 */}
//       {total > 0 ? (
//         <Range
//           step={1}
//           min={min}
//           max={total}
//           values={values}
//           onChange={handleChange}
//           renderTrack={({ props, children }) => (
//             <div
//               {...props}
//               style={{
//                 ...props.style,
//                 height: "6px",
//                 width: "100%",
//                 position: "relative",
//                 background: trackBackground,
//               }}
//             >
//               {children}
//             </div>
//           )}
//           renderThumb={({ props }) => (
//             <div
//               {...props}
//               style={{
//                 ...props.style,
//                 height: "19px",
//                 width: "6px",
//                 marginTop: "-7px",
//                 // borderRadius: "50%",
//                 backgroundColor: "black",
//               }}
//             />
//           )}
//         />
//       ) : (
//         // When total is 0, display a static gray bar as a placeholder.
//         <div style={{ height: "8px", width: "100%", background: "gray" }} />
//       )}
//     </div>
//   );
// };

// export default MultiProgress;




// In MultiProgress.jsx
// import React, { useState, useEffect } from "react";
// import { Range } from "react-range";

// const MultiProgress = ({ total: parentTotal, onSliderChange, min = 0 }) => {
//   const [total, setTotal] = useState(parentTotal || 0);
//   const [values, setValues] = useState([0, 0]);

//   useEffect(() => {
//     setTotal(parentTotal);
//     if (parentTotal > 0 && total === 0) {
//       const defaultLeft = Math.floor(parentTotal * 0.3);
//       const defaultRight = Math.floor(parentTotal * 0.55);
//       setValues([defaultLeft, defaultRight]);
//     }
//   }, [parentTotal]);

//   const firstSegment = values[0];
//   const secondSegment = values[1] - values[0];
//   const calculatedValue = total - values[1];

//   const handleChange = (newValues) => {
//     let [left, right] = newValues;
//     if (left > right) {
//       left = right;
//     }
//     left = Math.max(min, left);
//     right = Math.min(total, right);
//     setValues([left, right]);
//     if (onSliderChange) {
//       onSliderChange([left, right]);
//     }
//   };

//   const firstPercent = total > 0 ? (values[0] / total) * 100 : 0;
//   const secondPercent = total > 0 ? (values[1] / total) * 100 : 0;

//   const trackBackground =
//   total > 0
//     ? `linear-gradient(
//         to right,
//         green 0%,
//         green ${firstPercent}%,
//         yellow ${firstPercent}%,
//         yellow ${secondPercent}%,
//         red ${secondPercent}%,
//         red 100%
//       )`
//     : "lightgray"; // Ensures a gray progress bar when total is 0


//   return (
//     <div className="flex flex-col items-center w-full p-4">
//       <label className="mb-2 text-lg font-semibold">
//         Distribution: [{firstSegment} - {secondSegment} - {calculatedValue}]
//       </label>
//       {total > 0 ? (
//         <Range
//           step={1}
//           min={min}
//           max={total}
//           values={values}
//           onChange={handleChange}
//           renderTrack={({ props, children }) => (
//             <div
//               {...props}
//               style={{
//                 ...props.style,
//                 height: "6px",
//                 width: "100%",
//                 position: "relative",
//                 background: trackBackground,
//               }}
//             >
//               {children}
//             </div>
//           )}
//           renderThumb={({ props }) => (
//             <div
//               {...props}
//               style={{
//                 ...props.style,
//                 height: "19px",
//                 width: "6px",
//                 marginTop: "-7px",
//                 backgroundColor: "black",
//               }}
//             />
//           )}
//         />
//       ) : (
//         <div style={{ height: "8px", width: "100%", background: "gray" }} />
//       )}
//     </div>
//   );
// };

// export default MultiProgress;









// const MultiProgress = ({ total: parentTotal, onSliderChange, min = 0 }) => {
//   const [total, setTotal] = useState(parentTotal || 0);
//   const [values, setValues] = useState([0, 0]);

//   useEffect(() => {
//     setTotal(parentTotal);
//     if (parentTotal > 0 && total === 0) {
//       const defaultLeft = Math.floor(parentTotal * 0.3);
//       const defaultRight = Math.floor(parentTotal * 0.55);
//       setValues([defaultLeft, defaultRight]);
//     }
//   }, [parentTotal]);

import React, { useState, useEffect } from "react";
import { Range } from "react-range";
import "./multiprogress.css";

const MultiProgress = ({ total: parentTotal, onSliderChange, min = 0, defaultValues, isEnabled = true }) => {
  const [total, setTotal] = useState(parentTotal || 0);
  const [values, setValues] = useState([0, 0]);

  useEffect(() => {
    setTotal(parentTotal);

    if (parentTotal > 0) {
      if (defaultValues) {
        //  Set values from pattern if available
        const left = defaultValues.firstSegment || 0;
        const right = (defaultValues.firstSegment || 0) + (defaultValues.secondSegment || 0);
        setValues([left, right]);
      } else {
        // 🚫 Only use fallback default if no pattern
        const defaultLeft = Math.floor(parentTotal * 0.3);
        const defaultRight = Math.floor(parentTotal * 0.55);
        setValues([defaultLeft, defaultRight]);
      }
    }
  }, [parentTotal, defaultValues]); //  useEffect depends on defaultValues too


  const firstSegment = values[0];
  const secondSegment = values[1] - values[0]; // Between first and second thumb
  const calculatedValue = total - values[1]; // Remaining value

  const handleChange = (newValues) => {
    let [left, right] = newValues;
    if (left > right) {
      left = right;
    }
    left = Math.max(min, left);
    right = Math.min(total, right);
    setValues([left, right]);
    // if (onSliderChange) {
    //   onSliderChange([left, right]);
    // }
    if (onSliderChange) {
      onSliderChange({
        firstSegment: left,
        secondSegment: right - left,
        calculatedValue: total - right
      });
    }
  };

  const firstPercent = total > 0 ? (values[0] / total) * 100 : 0;
  const secondPercent = total > 0 ? (values[1] / total) * 100 : 0;

  const trackBackground =
    total > 0
      ? `linear-gradient(
          to right,
          #4A9D45 0%,
          #4A9D45 ${firstPercent}%,
          #FFBD20 ${firstPercent}%,
          #FFBD20 ${secondPercent}%,
          #FA4741 ${secondPercent}%,
          #FA4741 100%
        )`
      : "lightgray"; // Gray bar when total is 0

  return (
    <div className="flex flex-col items-center w-full p-4">
      {/* <label className="mb-2 text-lg font-semibold">
        Distribution: [{firstSegment} - {secondSegment} - {calculatedValue}]
      </label> */}
      {total > 0 ? (
        <div style={{ position: "relative", width: "100%", marginTop: "23px" }}>
          {/* Display firstSegment outside the green bar */}
          <div className="first-segment-box">
            {firstSegment}
          </div>

          <Range
           disabled={!isEnabled} 
            step={1}
            min={min}
            max={total}
            values={values}
            onChange={handleChange}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: "6px",
                  width: "100%",
                  position: "relative",
                  background: trackBackground,
                }}
              >
                {children}
              </div>
            )}
            renderThumb={({ props, index }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: "19px",
                  width: "6px",
                  marginTop: "-7px",
                  backgroundColor: "black",
                  // position: "relative",
                }}
              >
                {/* Show secondSegment on first scroll (left thumb) */}
                {index === 0 && (
                  <div className="second-segment-box">
                    {secondSegment}
                  </div>
                )}
                {/* Show calculatedValue on second scroll (right thumb) */}
                {index === 1 && (
                  <div className="third-segment-box">
                    {calculatedValue}
                  </div>
                )}
              </div>
            )}
          />
        </div>
      ) : (
        <div style={{ height: "8px", width: "100%", background: "gray", marginTop: "23px" }} />
      )}
    </div>
  );
};

export default MultiProgress;
